import React from 'react';
import './StartPage.scss';
import { emptySession } from '../variables/sessionVariables';

const StartPage = (props) => {
    const { toNext, updateVersion, t } = props;
    const onChange = (e) => {
        emptySession();
        updateVersion(e.currentTarget.getAttribute('version'));
        toNext();
    };

    return (
        <div className='StartPage'>
            <h1>{t('web.general.title')}</h1>
            {t('web.general.subtitle')
                .split('\n')
                .map((line, idx) => (
                    <p key={idx}>{line}</p>
                ))}
            <div className='versionSelection'>
                <button
                    className='mobileversion'
                    version='mobile'
                    onClick={onChange}
                >
                    <img src='images/estroke.png' alt='Mobil-app' />
                </button>
            </div>
            <div className='footer'>
                <p>
                    <a href='mailto:info@estroke.no'>
                        {t('web.general.footerEmail')}
                    </a>
                </p>
            </div>
        </div>
    );
};

export default StartPage;
